import { xmlDecl, el } from './index.js';
import { NS } from '../ns.js';
import type { HWPXDocument } from '../../../types.js';

export function generateContentHpfXml(doc: HWPXDocument): string {
  const sectionItems = doc.sections
    .map(
      (_, i) =>
        el('opf:item', {
          id: `section${i}`,
          href: `section${i}.xml`,
          'media-type': 'application/xml',
        }),
    )
    .join('\n');

  const sectionRefs = doc.sections
    .map((_, i) => el('opf:itemref', { idref: `section${i}` }))
    .join('\n');

  const binItems = doc.binData
    .map(
      (b) =>
        el('opf:item', {
          id: `bindata${b.id}`,
          href: `../BinData/${b.name}`,
          'media-type': getMimeType(b.format),
        }),
    )
    .join('\n');

  return (
    xmlDecl() +
    '\n' +
    el(
      'opf:package',
      {
        'xmlns:opf': NS.opf,
        version: '1.0',
        'unique-identifier': 'bookid',
      },
      '\n' +
      el(
        'opf:metadata',
        {},
        '\n' + el('opf:title', {}, doc.meta.title || '') + '\n',
      ) +
      '\n' +
      el(
        'opf:manifest',
        {},
        '\n' +
        el('opf:item', { id: 'header', href: 'header.xml', 'media-type': 'application/xml' }) +
        '\n' +
        sectionItems +
        '\n' +
        binItems +
        (binItems ? '\n' : ''),
      ) +
      '\n' +
      el(
        'opf:spine',
        {},
        '\n' + sectionRefs + '\n',
      ) +
      '\n',
    )
  );
}

function getMimeType(format: string): string {
  const map: Record<string, string> = {
    jpg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    tiff: 'image/tiff',
    wmf: 'image/x-wmf',
    emf: 'image/x-emf',
  };
  return map[format] || 'application/octet-stream';
}
